import {
    Box,
    Button,
    ButtonGroup,
    Flex,
    Grid,
    GridItem,
    Image,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverFooter,
    PopoverHeader,
    PopoverTrigger,
    SimpleGrid,
    Slider,
    SliderFilledTrack,
    SliderThumb,
    SliderTrack,
    Text,
    useColorModeValue
} from '@chakra-ui/react'
import React, {
    useEffect,
    useRef,
    useState
} from 'react'
import {
    IoHome,
    IoPause,
    IoPlay,
    IoTrash
} from 'react-icons/io5'
import {
    FcApproval
} from 'react-icons/fc'
import {
    Link,
    useNavigate,
    useParams
} from 'react-router-dom'
import { getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebase-config";
import { deleteVideo, getSpecificVideo, getUserInfo, recommendedFeed } from '../utils/fetchData'
import Spinner from './Spinner'
import ReactPlayer from 'react-player';
import {
    MdForward10,
    MdFullscreen,
    MdOutlineReplay10,
    MdVolumeOff,
    MdVolumeUp
} from "react-icons/md";

import lgl from "../img/lgl1.png";
import screenfull from 'screenfull';
import HTMLReactParser from 'html-react-parser';
import moment from 'moment/moment'
import { fetchUser } from '../utils/fetchUser'
import RecommendedVideos from './RecommendedVideos'

const format = (seconds) => {
    if (isNaN(seconds)) {
        return "00:00";
    }

    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = date.getUTCSeconds().toString().padStart(2, '0');

    if (hh) {
        return `${hh}:${mm.toString().padStart(2, '0')} : ${ss}`;
        //01:02:32
    }

    return `${mm}:${ss}`
    //02:35
}

const avatar = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTuhV7d2KM5ElJEfSRNnCJLwSqFw_D4yzutw&usqp=CAU'

const VideoPinDetail = () => {
    const firestoreDb = getFirestore(firebaseApp);
    const [localUser] = fetchUser();
    const navigate = useNavigate();

    const bg = useColorModeValue('blackAlpha.700', 'gray.900');
    const textcolor = useColorModeValue('gray.100', 'gray.100');
    const { videoId } = useParams()

    const [isLoading, setIsLoading] = useState(false)
    const [videoInfo, setVideoInfo] = useState(null)
    const [isPlaying, setIsPlaying] = useState(false)
    const [muted, setMuted] = useState(false)
    const [volume, setVolume] = useState(0.5)
    const [played, setPlayed] = useState(0)
    const [seeking, setSeeking] = useState(false)
    const [userInfo, setUserInfo] = useState(null)
    const [feeds, setFeeds] = useState(null)

    //custom ref
    const playerRef = useRef();
    const playerContainer = useRef()


    useEffect(() => {
        if (videoId) {
            setIsLoading(true);
            getSpecificVideo(firestoreDb, videoId).then((data) => {
                setVideoInfo(data);

                recommendedFeed(firestoreDb, data.category, videoId).then((feed) => {
                    setFeeds(feed);
                })

                getUserInfo(firestoreDb, data.userId).then((user) => {
                    setUserInfo(user);
                })


                setIsLoading(false);
            })
        }
    }, [videoId])

    useEffect(() => { }, [muted, volume, played])

    const onvolumechange = (e) => {
        setVolume(parseFloat(e / 100))

        e === 0 ? setMuted(true) : setMuted(false)
        console.log(e)
    }

    const handleFastRewind = () => {
        playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10)
    }
    const handleFastForward = () => {
        playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10)
    }
    const handleProgress = (changeState) => {
        if (!seeking) {
            setPlayed(parseFloat(changeState.played / 100) * 100)
        }
        console.log(changeState)
    }

    const handleSeekChange = (e) => {
        setPlayed(parseFloat(e / 100))
    }

    const onSeekMouseDown = (e) => {
        setSeeking(true)
    }

    const onSeekMouseUp = (e) => {
        setSeeking(false)
        playerRef.current.seekTo(e / 100)
    }

    const currentTime = playerRef.current ? playerRef.current.getCurrentTime() : "00:00";

    const duration = playerRef.current ? playerRef.current.getDuration() : "00:00";


    const elapsedTime = format(currentTime);

    const totalDuration = format(duration);

    const deleteTheVideo = (videoId) => {
        setIsLoading(true);
        deleteVideo(firestoreDb, videoId);
        navigate('/', { replace: true })
    }


    if (isLoading) return <Spinner />

    return (
        <Flex
            width={'full'}
            height='auto'
            justifyContent={'center'}
            alignItems='center'
            direction={'column'}
            py={2}
            px={4}
        >
            <Flex
                alignItems={'center'}
                width='full'
                my={4}
            >
                <Link
                    to={'/'}
                >
                    <IoHome fontSize={25} />
                </Link>
                <Box
                    width='1px'
                    height={'25px'}
                    bg={'gray.500'}
                    mx={2}
                >
                </Box>

                <Text
                    isTruncated
                    color={textcolor}
                    fontWeight='semibold'
                    width={'100%'}
                >
                    {videoInfo?.title}
                </Text>
            </Flex>

            {/* main grid for video */}

            <Grid
                templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }}
                gap={2}
                width={'100%'}
            >
                <GridItem
                    width={'100%'}
                    colSpan={{ base: '1', md: '2', lg: '3' }}
                >
                    <Flex
                        width={'full'}
                        bg='black'
                        position='relative'
                        ref={playerContainer}
                        mb={{base: '120px', md: '150px', lg: '150px'}}
                    >
                        <ReactPlayer
                            ref={playerRef}
                            url={videoInfo?.videoUrl}
                            width='100%'
                            height={'100%'}
                            playing={isPlaying}
                            muted={muted}
                            volume={volume}
                            onProgress={handleProgress}
                        />
                        {/* controls for video player */}
                        <Flex
                            position={'absolute'}
                            height={{base: '260px', md: '330px', lg: '600px'}}
                            top={0}
                            left={0}
                            right={0}
                            bottom={0}
                            direction='column'
                            justifyContent={'space-between'}
                            alignItmes='center'
                            zIndex={1}
                            cursor='pointer'
                        >

                            {/* play icon */}

                            <Flex
                                justifyContent={'center'}
                                alignItems='center'
                                onClick={() => { setIsPlaying(!isPlaying) }}
                                width='full'
                                height='full'
                            >
                                {!isPlaying && (
                                    <IoPlay
                                        fontSize={40} color='rgba(79, 209, 197, 1)'
                                        cursor={'pointer'} />
                                )}
                            </Flex>

                            {/* progress control */}
                            <Flex
                                width={'full'}
                                alignItems='center'
                                direction={'column'}
                                px={4}
                                bgGradient='linear(to-t, blackAlpha.900, blackAlpha.500, blackAlpha.50)'
                            >

                                <Slider
                                    aria-label='slider-ex-4'
                                    min={0}
                                    max={100}
                                    value={played * 100}
                                    transition='ease-in-out'
                                    transitionDuration={'0.2'}
                                    onChange={handleSeekChange}
                                    onMouseDown={onSeekMouseDown}
                                    onChangeEnd={onSeekMouseUp}
                                >
                                    <SliderTrack
                                        bg='teal.50'>
                                        <SliderFilledTrack
                                            bg='teal.300' />
                                    </SliderTrack>
                                    <SliderThumb
                                        boxSize={{ base: '2', md: '3', lg: '3' }}
                                        bg='teal.300'
                                        transition='ease-in-out'
                                        transitionDuration={'0.2'}
                                    >
                                    </SliderThumb>
                                </Slider>

                                {/* other controls */}
                                <Flex
                                    width={'full'}
                                    alignItems='center'
                                    my={2}
                                    gap={{ base: '2px', md: '3px', lg: '10px' }}
                                >

                                    <MdOutlineReplay10
                                        fontSize={{ base: '24px', md: '40px', lg: '56px' }}
                                        // fontSize={{ base: 10, md: 20, lg: 30 }}
                                        color={'#f1f1f1'}
                                        cursor='pointer'
                                        onClick={handleFastRewind}
                                    />

                                    <Box
                                        onClick={() => { setIsPlaying(!isPlaying) }}
                                    >
                                        {!isPlaying ? (
                                            <IoPlay
                                                fontSize={{ base: 10, md: 20, lg: 30 }}
                                                color='f2f2f2'
                                                cursor={'pointer'} />
                                        ) : (
                                            <IoPause
                                                fontSize={{ base: 10, md: 20, lg: 30 }}
                                                color='f2f2f2'
                                                cursor={'pointer'} />
                                        )}
                                    </Box>

                                    <MdForward10
                                        fontSize={{ base: 10, md: 20, lg: 30 }}
                                        color={'#f1f1f1'}
                                        cursor='pointer'
                                        onClick={handleFastForward}
                                    />
                                    {/* volume control */}
                                    <Flex
                                        alignItems={'center'}
                                    >
                                        <Box
                                            onClick={() => setMuted(!muted)}
                                        >
                                            {!muted ? (
                                                <MdVolumeUp fontSize={{ base: '10px', md: '20', lg: '30' }}
                                                    color='#f1f1f1'
                                                    cursor={"pointer"} />
                                            ) : (
                                                <MdVolumeOff fontSize={{ base: 10, md: 20, lg: 30 }}
                                                    color='#f1f1f1'
                                                    cursor={"pointer"} />
                                            )}
                                        </Box>
                                        <Slider
                                            aria-label='slider-ex-1'
                                            defaultValue={volume * 100}
                                            min={0}
                                            max={100}
                                            size='sm'
                                            width={16}
                                            mx={2}
                                            onChangeStart={onvolumechange}
                                            onChangeEnd={onvolumechange}
                                        >
                                            <SliderTrack bg='teal.50'>
                                                <SliderFilledTrack bg='teal.300' />
                                            </SliderTrack>
                                            <SliderThumb boxSize={2} bg='teal.300'>
                                            </SliderThumb>
                                        </Slider>
                                    </Flex>
                                    {/* duration of video */}
                                    <Flex
                                        alignItems={'center'}
                                        gap={2}
                                    >
                                        <Text fontSize={{ base: '7px', md: '10px', lg: '16px' }} color='whitesmoke'>{elapsedTime}</Text>
                                        <Text fontSize={{ base: '7px', md: '10px', lg: '16px' }} color='whitesmoke'>/</Text>
                                        <Text fontSize={{ base: '7px', md: '10px', lg: '16px' }} color='whitesmoke'>{totalDuration}</Text>

                                    </Flex>
                                </Flex>
                                <Flex
                                    ml='auto'
                                >
                                    <Image src={lgl} width={{ base: '60px', md: '70px', lg: '80px' }} />
                                    <MdFullscreen
                                        fontSize={{ base: '50px', md: '60px', lg: '80px' }}
                                        color='#f1f1f1'
                                        cursor='pointer'
                                        my='auto'
                                        onClick={() => {
                                            screenfull.toggle(playerContainer.current)
                                        }}
                                    />
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>



                    {/* video description */}

                    {
                        videoInfo?.description && (
                            <Flex
                                my={6}
                                direction='column'
                            >
                                <Text
                                    my={2}
                                    fontSize={25}
                                    fontWeight='semibold'
                                >
                                    Description
                                </Text>
                                {
                                    HTMLReactParser(videoInfo?.description)
                                }
                            </Flex>
                        )
                    }



                </GridItem>
                <GridItem
                    width={'100%'}
                    colSpan={{ base: '1', md: '1', lg: '1' }}
                >
                    {
                        userInfo && (
                            <Flex
                                direction={'column'}
                                width={'full'}
                            >
                                <Flex
                                    alignItems={'center'}
                                    width='full'
                                >

                                    <Image
                                        src={userInfo?.photoURL ? userInfo?.photoURL : avatar}
                                        rounded='full'
                                        width={'60px'}
                                        height={'60px'}
                                        border='2px'
                                        minHeight={'60px'}
                                        minWidth={'60px'}
                                        borderColor={bg}
                                    />

                                    <Flex
                                        direction={'column'}
                                        ml={3}
                                    >
                                        <Flex
                                            alignItems={'center'}
                                        >
                                            <Text
                                            fontSize={{base: '12px', md: '12px', lg: '12px'}}
                                                isTruncated
                                                color={textcolor}
                                                fontWeight='semibold'
                                            >
                                                {userInfo?.displayName}
                                            </Text>
                                            <FcApproval />
                                        </Flex>

                                        {
                                            videoInfo?.id && (
                                                <Text
                                                    fontSize={12}
                                                >
                                                    {
                                                        moment(new Date(parseInt(videoInfo.id)).toISOString()).fromNow()
                                                    }
                                                </Text>
                                            )
                                        }

                                    </Flex>

                                </Flex>
                                <Flex
                                    justifyContent={'space-around'}
                                    mt={6}
                                >
                                    {
                                        userInfo?.uid === localUser.uid && (
                                            <Popover closeOnEsc>
                                                <PopoverTrigger>
                                                    <Button
                                                        colorScheme={'red'}
                                                    ><IoTrash fontSize={30} color='#fff' /></Button>
                                                </PopoverTrigger>
                                                <PopoverContent>
                                                    <PopoverArrow />
                                                    <PopoverCloseButton />
                                                    <PopoverHeader>Do you want to delete your video!</PopoverHeader>
                                                    <PopoverBody>Are you sure you want to delete it?</PopoverBody>
                                                    <PopoverFooter display='flex' justifyContent='flex-end'>
                                                        <ButtonGroup size='sm'>
                                                            <Button colorScheme='red'
                                                                onClick={() => deleteTheVideo(videoId)}
                                                            >Yes</Button>
                                                        </ButtonGroup>
                                                    </PopoverFooter>
                                                </PopoverContent>
                                            </Popover>
                                        )
                                    }
                                    <a
                                        href={videoInfo.videoUrl}
                                        download
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <Button
                                            colorScheme={'whatsapp'}
                                            rounded='full'
                                            my={2}
                                            mt={'0'}
                                            fontSize={'8px'}
                                        >
                                            <Text fontSize={'12px'}>Free Download</Text>
                                        </Button>
                                    </a>
                                </Flex>
                            </Flex>
                        )
                    }
                </GridItem>
            </Grid>
            {
                feeds && (
                    <Flex
                        direction={'column'}
                        width='full'
                        my={6}
                    >
                        <Text
                            my={4}
                            fontSize={25}
                            fontWeight='semibold'
                        >
                            Recommended Videos
                        </Text>
                        <RecommendedVideos feeds={feeds} />
                    </Flex>
                )
            }
        </Flex>
    )
}

export default VideoPinDetail